var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgS2IconRename = function SvgS2IconRename(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.405 14.137 7.864 3.402c-.212-.5-1.032-.5-1.244 0L2.078 14.137a.675.675 0 1 0 1.244.525L4.956 10.8h4.571l1.634 3.863a.675.675 0 0 0 1.244-.526ZM5.527 9.45l1.715-4.053L8.956 9.45H5.527ZM14.625 16.875a.675.675 0 0 1-.675-.675V1.8a.675.675 0 0 1 1.35 0v14.4a.675.675 0 0 1-.675.675Z"
  })));
};
export default SvgS2IconRename;